import defaultStates from '@/constants/lifecycle';

export const workspaceActions = {
  CLOSE_REQUEST_WORKSPACE: 'CLOSE_REQUEST_WORKSPACE',
  DESTROY_REQUEST_WORKSPACE: 'DESTROY_REQUEST_WORKSPACE',
  NEW_WORKSPACE_REQUEST: 'NEW_WORKSPACE_REQUEST',
  REQUEST_WORKSPACE: 'REQUEST_WORKSPACE',
  REQUEST_WORKSPACE_ERROR: 'REQUEST_WORKSPACE_ERROR',
  REQUEST_WORKSPACE_SUCCESS: 'REQUEST_WORKSPACE_SUCCESS',
};

const workspaceLocationActions = {
  FETCH_WORKSPACE_LOCATIONS: 'FETCH_WORKSPACE_LOCATIONS',
  SHOW_WORKSPACE_LOCATIONS: 'SHOW_WORKSPACE_LOCATIONS',
  SHOW_WORKSPACE_LOCATIONS_ERROR: 'SHOW_WORKSPACE_LOCATIONS_ERROR',
};

export const workspaceFormActions = {
  FETCH_WORKSPACE_FORM: 'FETCH_WORKSPACE_FORM',
  HEALTH_WORKSPACE_FORM: 'HEALTH_WORKSPACE_FORM',
  HIDE_WORKSPACE_REQUEST_RECEIPT: 'HIDE_WORKSPACE_REQUEST_RECEIPT',
  SHOW_WORKSPACE_FORM: 'SHOW_WORKSPACE_FORM',
  SHOW_WORKSPACE_FORM_ERROR: 'SHOW_WORKSPACE_FORM_ERROR',
  SHOW_WORKSPACE_FORM_HEALTH_ERROR: 'SHOW_WORKSPACE_FORM_HEALTH_ERROR',
  SHOW_WORKSPACE_FORM_HEALTH_SUCCESS: 'SHOW_WORKSPACE_FORM_HEALTH_SUCCESS',
  SHOW_WORKSPACE_REQUEST_RECEIPT: 'SHOW_WORKSPACE_REQUEST_RECEIPT',
};

export const workspaceStates = {
  ...defaultStates,
};

export const workspaceForms = {
  REQUEST: 'workspace_request',
};

export const workspaceFormHealthSources = {
  DAR: 'data access request',
  WORKSPACE: 'workspace request',
};

export const workspaceRequestSteps = {
  WORKSPACE: { name: 'workspace', icon: 'cube' },
  COMPLETE: { name: 'complete', icon: 'hourglass start' },
};

export const workspaceReferenceFieldCode = 'e63a8cdd-2e9a-4f6f-95b4-3be796c77c31';

export default workspaceLocationActions;
